var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepBlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78856 15.3971C4.38223 12.2997 2.77206 4.95047 2.77206 4.95047C2.77206 4.95047 9.99054 2.5107 15.3969 5.60811C20.8036 8.70574 22.35 16.1671 22.35 16.1671C22.35 16.1671 15.1953 18.4947 9.78856 15.3971Z",
    fill: "#E1C3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4541 26.0753C14.8565 28.4607 9.80547 27.1746 9.80547 27.1746C9.80547 27.1746 10.5373 21.9468 14.1349 19.5613C17.7327 17.1757 22.8334 18.5361 22.8334 18.5361C22.8334 18.5361 22.052 23.6896 18.4541 26.0753Z",
    fill: "#F8D146"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepBlockIcon);
export default __webpack_public_path__ + "static/media/step-block-icon.a8c91e7811f2b7189a210f67e83be466.svg";
export { ForwardRef as ReactComponent };